import type { Permission } from '@repo/contracts';
import { Navigate, Outlet } from 'react-router';

import { APP_ROUTES } from '@/constants/app-routes';
import { selectCan } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

interface RequirePermissionProps {
  permission: Permission;
}

/**
 * Turns a page away before it mounts, so it never fires the requests the
 * gateway would refuse. Without it, a URL typed by someone who may not read
 * the page showed an empty table and an access error, which reads as a
 * broken screen rather than a closed one. The dashboard is where a role with
 * nowhere else to go is given a plain page.
 */
export function RequirePermission({ permission }: RequirePermissionProps) {
  const allowed = useAppSelector(selectCan(permission));

  if (!allowed) return <Navigate to={APP_ROUTES.dashboard} replace />;

  return <Outlet />;
}
